// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"661":"227a8494","878":"227a8494"}[chunkId] + ".css";
};